import { ProductCategoryEntity } from '../../types';

export enum ProductsCategoriesActions {
  FetchCategoriesBegin = 'PRODUCTS/FETCH_CATEGORIES/BEGIN',
  FetchCategoriesSuccess = 'PRODUCTS/FETCH_CATEGORIES/SUCCESS',
  FetchCategoriesError = 'PRODUCTS/FETCH_CATEGORIES/ERROR',
}

export enum ProductsCategoriesCountActions {
  FetchCategoriesBegin = 'PRODUCTS/FETCH_CATEGORIES_COUNT/BEGIN',
  FetchCategoriesSuccess = 'PRODUCTS/FETCH_CATEGORIES_COUNT/SUCCESS',
  FetchCategoriesError = 'PRODUCTS/FETCH_CATEGORIES_COUNT/ERROR',
}

export interface ProductsCategoriesStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  productCategories: ProductCategoryEntity[];
}
